module.exports = __webpack_public_path__ + "static/demo-02-c29c30b39305a829edf41ab681ce068e.mp4";